
<div :data-component-name="$options.name" class="h-100 margins">
  <div :style="styleObject" class="general h-100">
    <div class="div_general">
      <div class="space-between">
        <span
          v-if="content.idJeu != null"
          :class="['progressif ' + content.tailleProgressif + ' ' + content.idJeu]"
        ></span>
        <div>
          <div
            class="surTitre graphik_bold"
            :style="[{ color: content.couleurTitre }]"
            v-html="content.surTitre"
          ></div>
          <div
            class="titre_mediaImage graphik_bold"
            :style="[{ color: content.couleurTitre }]"
            v-html="content.titre"
          ></div>
        </div>

        <b-link
          v-if="content.lien"
          v-bind="jel_getLienBinding(content.lien)"
          class="stretched-link publicite-en-vedette"
          :ga-img-name="imageName"
          :data-tag="`${jel_getNomRouteCourante()} ${content.surTitre} - ${content.titre.replace(
            /&nbsp;/g,
            ' '
          )} - ${content.dataTag}`"
        >
          <div v-if="content.texteBouton">
            <button
              class="btn mt-2 graphik_semibold texteBouton"
              :style="[
                { 'border-color': content.borderColorBtn },
                { 'background-color': content.colorBtn },
              ]"
            >
              {{ content.texteBouton }}
            </button>
          </div>
        </b-link>
      </div>
    </div>
  </div>
</div>
